module.exports = __webpack_public_path__ + "img/edit_icon.3c8e9466.svg";